import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useFitnessStore = create(
  persist(
    (set, get) => ({
      activeScreen: 'home',
      setScreen: (screen) => set({ activeScreen: screen }),

      profile: {
        name: 'Champion',
        weight: 85,
        height: 180,
        age: 28,
        gender: 'male',
        fitnessLevel: 'advanced',
        goals: ['strength', 'endurance'],
        sport: 'powerlifting',
        subscriptionTier: 'free',
        activityLevel: 'active',
      },
      setProfile: (updates) => set((state) => ({ profile: { ...state.profile, ...updates } })),

      activeWorkout: null,
      setActiveWorkout: (workout) => set({ activeWorkout: workout }),

      workoutHistory: [],
      logWorkout: (workout) => set((state) => ({
        workoutHistory: [{ ...workout, date: new Date().toISOString(), id: Date.now() }, ...state.workoutHistory].slice(0, 200),
      })),

      bodyStats: [],
      logBodyStat: (stat) => set((state) => ({
        bodyStats: [{ ...stat, date: new Date().toISOString() }, ...state.bodyStats].slice(0, 365),
      })),

      weeklyStats: { workouts: 5, minutes: 228, calories: 2140, streak: 14 },
      updateStats: (updates) => set((state) => ({ weeklyStats: { ...state.weeklyStats, ...updates } })),

      coachMessages: [],
      addCoachMessage: (msg) => set((state) => ({ coachMessages: [...state.coachMessages, msg].slice(-50) })),

      modal: null,
      openModal: (type, data = null) => set({ modal: { type, data } }),
      closeModal: () => set({ modal: null }),

      aiUsageToday: { coach: 0, plans: 0, date: new Date().toDateString() },
      incrementAIUsage: (type) => {
        const today = new Date().toDateString();
        const state = get();
        const usage = state.aiUsageToday.date === today
          ? state.aiUsageToday
          : { coach: 0, plans: 0, date: today };
        set({ aiUsageToday: { ...usage, [type]: usage[type] + 1, date: today } });
      },
    }),
    {
      name: 'fitlife-v1',
      partialize: (s) => ({
        profile: s.profile,
        workoutHistory: s.workoutHistory,
        bodyStats: s.bodyStats,
        weeklyStats: s.weeklyStats,
        aiUsageToday: s.aiUsageToday,
      }),
    },
  ),
);
